import { render } from "./DeleteSandboxJobs.vue?vue&type=template&id=6c29da67"
import script from "./DeleteSandboxJobs.vue?vue&type=script&lang=js"
export * from "./DeleteSandboxJobs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__